import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsStrategist, selectManagers } from "../Redux/Reducers/selectors";
import { getUserState } from "../Redux/Reducers/userReducer";

// Define allowed routes for strategists
// This must match the filtering logic in MainRoutes.js
const STRATEGIST_ALLOWED_ROUTES = [
    '/portfolio',
    '/signals',
    '/strategies',
    '/historical-signals'
];

const AuthorizedRoute = ({ children }) => {
    const location = useLocation();
    const isStrategist = useSelector(selectIsStrategist);
    const managers = useSelector(selectManagers);
    const user = useSelector(getUserState);
    const socketuser = useSelector((state) => state?.users?.userInfo);

    // First check if user is authenticated (same logic as MainRoutes)
    const token = user?.idToken;
    const isAuthenticated = token && Object.keys(socketuser || {}).length > 0;
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Check if strategist is trying to access a restricted route
    if (isStrategist) {
        // Check if current path is allowed for strategists
        // Use more precise matching to handle routes with parameters
        const isAllowedRoute = STRATEGIST_ALLOWED_ROUTES.some(allowedRoute => {
            // Check exact match first
            if (location.pathname === allowedRoute) return true;
            // Check if path starts with allowed route (handles parameterized routes)
            if (location.pathname.startsWith(allowedRoute + '/')) return true;
            return false;
        });

        if (!isAllowedRoute) {
            // Redirect to portfolio page (first allowed route) instead of login
            // since they are authenticated but just don't have permission
            return <Navigate to="/portfolio" replace />;
        }
    }

    // For non-strategists or allowed routes, render the component
    return children;
};

export default AuthorizedRoute;
